import DataManager from "../common/core/DataManager";

class ResultModal {
  // ---------------------------------------------------------------------------------------------------------
  // --	ResultModal
  // ---------------------------------------------------------------------------------------------------------

  constructor() {
    //準備済みフラグ
    this.isReady = false;

    //インデックス初期値
    this.index = -1;

    //ロックフラグ
    this.isLock = true;

    //dom参照
    this.$dom = $(".c-result-modal");
    this.$wrapper = $(".c-result-modal__wrapper");
    this.$box = $(".c-result-modal__box");

    //テンプレート読み込み
    $.get("./assets/data/result-modal.tmpl.html").done((data) => {
      this.tmpl = $.templates(data);
      this.isReady = true;
    });

    //閉じるボタン
    this.$dom.find(".js-close-btn").click((e) => {
      this.close();
      return false;
    });

    //次へボタン
    this.$dom.find(".js-next-btn").click((e) => {
      this.changePage(1);
      return false;
    });

    //前へボタン
    this.$dom.find(".js-back-btn").click((e) => {
      this.changePage(-1);
      return false;
    });
  }

  open(index) {
    if (!this.isReady) return;

    //ロック
    this.isLock = true;

    //インデックス
    this.index = index;

    //BOXの内容更新
    this.updateBox();

    //初期表示
    this.$dom.css("display", "flex");
    gsap.set(this.$dom, { alpha: 0 });
    gsap.set(this.$wrapper, { alpha: 0, y: 50 });

    //Tween
    gsap.to(this.$dom, 0.2, {
      alpha: 1,
      ease: "none",
      onComplete: () => {
        gsap.to(this.$wrapper, 0.3, {
          alpha: 1,
          ease: "none",
        });
        gsap.to(this.$wrapper, 0.6, {
          y: 0,
          ease: "back.out(1.7)",
          onComplete: () => {
            this.isLock = false;
          },
        });
      },
    });
  }

  close() {
    if (!this.isReady) return;
    if (this.isLock) return;

    //ロック
    this.isLock = true;

    //フェードアウト
    gsap.killTweensOf(this.$dom);
    gsap.killTweensOf(this.$wrapper);
    gsap.to(this.$dom, 0.2, {
      alpha: 0,
      ease: "none",
      onComplete: () => {
        this.$dom.css("display", "none");
      },
    });
  }

  updateBox() {
    //モデル参照
    const models = DataManager.getData("models");
    const model = models[this.index];

    //問題数のクラス追加
    this.$box.removeClass(function (index, className) {
      let removeClassName = "q";
      let reg = new RegExp("\\b" + removeClassName + "\\S+", "g");
      return (className.match(reg) || []).join(" ");
    });
    this.$box.addClass("q" + model.no);

    //レンダリング
    const result = this.tmpl.render(model);
    this.$box.html(result);
  }

  changePage(dir) {
    if (this.isLock) return;

    //インデックス更新
    this.index += dir;
    if (this.index < 0) this.index = 19;
    if (this.index > 19) this.index = 0;

    //スライド
    gsap.to(this.$wrapper, 0.1, {
      alpha: 0,
      ease: "none",
      onStart: () => {
        this.isLock = true;
      },
      onComplete: () => {
        gsap.delayedCall(0.1, () => {
          this.updateBox();
          gsap.set(this.$wrapper, { alpha: 0, x: 50 * dir });
          gsap.to(this.$wrapper, 0.3, {
            alpha: 1,
            ease: "none",
          });
          gsap.to(this.$wrapper, 0.6, {
            x: 0,
            ease: "back.out(1.7)",
            onComplete: () => {
              this.isLock = false;
            },
          });
        });
      },
    });
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default ResultModal;
